module.exports = __webpack_public_path__ + "arrow-right-white.svg?7740b438c945dc9c2bbaf6550c1c60f2";